import Vue from 'vue'
import {allUserRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import {TaskTypeForCalendarShiftHoverEnum} from '@/enums/TaskTypeForCalendarShiftHoverEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import format from 'date-fns/format';
import { convertDateStringToUTCDate } from '@/utils/dateUtil';
import GenericModal from '@/componentsReusable/genericModal.vue';
import WarningModal from '@/componentsReusable/WarningModal.vue';
import ProviderModal from '@/componentsReusable/ProviderModal.vue';
import LogisticsTaskCreationModal from "@/componentsReusable/LogisticsTaskCreationModal.vue";
import CustomMonthPicker from './calendarShiftsComponents/CustomMonthPicker.vue';
import FilterComponent from '@/componentsReusable/FilterComponent.vue';
import {
  FACILITY_FILTER_TYPE,
  facilityUserFilterTypes,
  FILLED_ID, HAITUS_ID, SHIFT_FILTER_TYPE, SPECIALTY_FILTER_TYPE,
  UNFILLED_ID, ALL_OPEN_ID, OPEN_TRAVEL_ID, OPEN_LICENSING_ID, OPEN_CREDENTIALING_ID, ALL_LOGISTICS_ID
} from '@/enums/CalendarFacilityUserFilterTypes';
import { ViewStateType } from '@/enums/ViewStateType';
import { Filter } from '@/components/calendarShifts/filterModel';
import { getProviderStatusIndicator } from '@/components/providers/ProviderSearchResultModel';

export default Vue.extend({
  name: 'CalendarShifts',
  data () {
    let tempStartingDate = this.$store.state.viewState[ViewStateType.CALENDAR_STARTING_DATE] ? new Date(this.$store.state.viewState[ViewStateType.CALENDAR_STARTING_DATE]) : new Date();
    return {
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      token: 'empty',
      loadingData: false,
      loadingMonthData: false,
      loadingAssignedUnassignedHoursReport: false,
      startingDate: tempStartingDate,
      weeks: [] as any[],
      allWeeks: [] as any[],
      wholeMonth: [] as any[],
      clickStartTime: 0,
      clickedShiftId: 0,
      hoveredFacilityName: '',
      hoveredSpecialtyName: '',
      onHoveredFacilityName: '',
      onHoveredSpecialtyName: '',
      hoveredProvider: '',
      hoveredShiftHours: '',
      hoveredStartDatetime: '',
      hoveredEndDatetime: '',
      showShiftInformation: false,
      shiftInformationStyles: { transform: "translate(-300px, -300px);" },
      facilitySpecialtyInformationStyles: { transform: "translate(-300px, -300px);" },
      showFacilitySpecialtyInformation: false,
      calendarBodyElement: null as HTMLElement | null,
      scrollEventTimeout: null as NodeJS.Timer | null,
      getMoreContentThreshold: 500,
      selectedShifts: [] as any[],
      showShiftActionsDropdown: false,
      showShiftFiltersDropdown: false,
      reloadingData: false,
      providerToAssign: null,
      showLogisticsModal: false,
      confirmationModalVerbiage: "Are you sure?",
      confirmationModalAction: function () {},
      showConfirmationModal: false,
      showProviderSelectionModal: false,
      showCalendarHoursReport: true,
      searchCountResults: 0,
      shiftSearchResults: [] as any,
      shiftSearchResultsShowLimit: 5,
      moreShiftSearchResultsAvailable: false,
      isHiatus: false,
      shiftFiltersSelected: 0,
      shiftFilterFacilities: [] as Filter[] ,
      shiftFilterSpecialties: [] as Filter[],
      shiftFilterProviders: [] as Filter[],
      shiftFilterFilled: [] as Filter[],
      shiftFilterStates: [] as any[],
      shiftFilterShifts: [] as Filter[],
      shiftFilterProviderOwners: [] as Filter[],
      shiftFilterFacilityOwners: [] as Filter[],

      hoveredTasks: ['', '', '', '', ''],
      logisticsSearchResults: [] as any,
      shiftFilterLogistics: [] as Filter[],

      shiftFilterTypes: [
        {id:1, name:"Facility", isSelected:true, searchAPI:'/api/facilities/search?facilityNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.name;
              responseObject.shiftFilterTypeId = 1;
              return responseObject;
            });
          }
        },
        {id:2, name:"Specialty", isSelected:false, searchAPI:'/api/specialties/search?specialtyNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.specialty;
              responseObject.shiftFilterTypeId = 2;
              return responseObject;
            });
          }
        },
        {id:3, name:"Provider", isSelected:false, searchAPI:'/api/providers/search?providerNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.firstName + ' ' + responseObject.lastName;
              responseObject.name = responseObject.title ? responseObject.name + ' | ' + responseObject.title : responseObject.name;
              responseObject.prefixHtml = getProviderStatusIndicator(responseObject.statusId);
              responseObject.location = '';
              if (responseObject.city && responseObject.state) {
                responseObject.location = `${responseObject.city}, ${responseObject.state}`;
              }
              responseObject.shiftFilterTypeId = 3;
              return responseObject;
            });
          }
        },
        {id:4, name:"State", isSelected:false, searchAPI:'/api/states/search?stateNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.stateFullName;
              responseObject.shiftFilterTypeId = 4;
              return responseObject;
            });
          }
        },
        {id:5, name:"Shift", isSelected:false, searchAPI:'/api/states/search?stateNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.stateFullName;
              responseObject.shiftFilterTypeId = 5;
              return responseObject;
            });
          }
        },
        {id:6, name:"Provider Owner", isSelected:false, searchAPI:'/api/nmr-employees/search?role=1&role=2&employeeNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.fullName;
              responseObject.shiftFilterTypeId = 6;
              return responseObject;
            });
          }
        },
        {id:7, name:"Facility Owner", isSelected:false, searchAPI:'/api/nmr-employees/search?role=1&role=2&employeeNameLike=',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.fullName;
              responseObject.shiftFilterTypeId = 7;
              return responseObject;
            });
          }
        },
        {id:8, name:"Logistics", isSelected:false, searchAPI:'',
          conditionResponseData: function(responseData:any){
            return responseData.map((responseObject:any) => {
              responseObject.name = responseObject.fullName;
              responseObject.shiftFilterTypeId = 8;
              return responseObject;
            });
          }
        },
      ],
      shiftFilterSearchInput: '',
      logisticsFilterSearchInput: '',
      processingShiftFilterSearch: false,
      loadingShiftFilterSearchResults: false,
      showShiftActionsWarningModal: false,
      assignedHours: '0',
      unassignedHours: '0',
      totalMonthHours: '0',
      assignedPercentage: '0',
      unassignedPercentage: '0',
      includeOpen: true,
      facilityFilterTypes: facilityUserFilterTypes,
      isWeekView: false,
      weekMonthViewLabel: '',
      months: [] as any [],
      monthWeekGridRowStyle: { "grid-template-columns": "120px repeat(70, 1fr);" } as any,
      isBrowserMSEdge: false
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal,
    WarningModal,
    ProviderModal,
    LogisticsTaskCreationModal,
    CustomMonthPicker,
    FilterComponent,
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](allUserRoles);
    this.token = this.$store.state.user.token;
  },
  async created() {

    this.shiftFilterFacilities = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_FACILITIES] || [];
    this.shiftFilterProviders = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_PROVIDERS] || [];
    this.shiftFilterSpecialties = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_SPECIALTIES] || [];
    this.shiftFilterStates = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_STATES] || [];
    this.shiftFilterShifts = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_SHIFTS] || [];
    this.shiftFilterProviderOwners = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_PROVIDER_OWNERS] || [];
    this.shiftFilterFacilityOwners = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_FACILITY_OWNERS] || [];
    this.shiftFilterLogistics = this.$store.state.viewState[ViewStateType.CALENDAR_SHIFT_FILTER_LOGISTICS] || [];

    this.isHiatus = this.shiftFilterShifts.some((shiftFilter) => shiftFilter.id === HAITUS_ID);

    await this.toggleWeekMonthView(this.isWeekView);
    this.startingDate = this.$store.state.viewState[ViewStateType.CALENDAR_STARTING_DATE] ? new Date(this.$store.state.viewState[ViewStateType.CALENDAR_STARTING_DATE]) : new Date();
    this.isBrowserMSEdge = window.navigator.userAgent.indexOf("Edge") > -1;
  },
  mounted: function () {
    this.calendarBodyElement = document.getElementById("calendar-body");
    if (this.calendarBodyElement) {
      this.calendarBodyElement.addEventListener('scroll', this.onCalendarBodyScroll);
    }
    let self = this;
    setTimeout(function () {
      self.onCalendarBodyScroll();
    },500);
  },
  destroyed: function () {
    if (this.calendarBodyElement) {
      this.calendarBodyElement.removeEventListener('scroll', this.onCalendarBodyScroll);
    }
  },
  filters: {
    dateStringMonthName (dateString: string) {
      let tempDate = new Date(dateString);
      let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return months[tempDate.getUTCMonth()];
    },
    dateStringDate (dateString: string) {
      return +dateString.slice(8,10);
    },
    facilitySpecialtyShortNames (facilitySpecialty: any) {
      return facilitySpecialty.specialtyShortName ? facilitySpecialty.facilityDisplayName + ' | ' + facilitySpecialty.specialtyShortName : facilitySpecialty.facilityDisplayName;
    },
    formatShiftTimes (shift: any) {
      let formattedTimes = format(convertDateStringToUTCDate(shift.shiftStartDatetime) as any, 'h:mma');
      formattedTimes += ' - ' + format(convertDateStringToUTCDate(shift.shiftEndDatetime) as any, 'h:mma');
      return formattedTimes;
    },
    formatShiftTimesAP (shift: any) {
      let formattedTimes = (format(convertDateStringToUTCDate(shift.shiftStartDatetime) as any, 'a')).slice(0,1);
      formattedTimes += '-' + (format(convertDateStringToUTCDate(shift.shiftEndDatetime) as any, 'a')).slice(0,1);
      return formattedTimes;
    },
    formatShiftProviderName (shift: any) {
      return shift.providerLastName + ', ' + shift.providerFirstName.slice(0,1) + '.' ;
    },
    formatShiftProviderNameInitials (shift: any) {
      return shift.providerLastName.slice(0,1).toUpperCase() + '.' + shift.providerFirstName.slice(0,1) + '.' ;
    },
  },
  watch: {
    shiftFilterFacilities () { this.setShiftFiltersSelected(); },
    shiftFilterSpecialties () { this.setShiftFiltersSelected(); },
    shiftFilterProviders () { this.setShiftFiltersSelected(); },
    shiftFilterStates () { this.setShiftFiltersSelected(); },
    shiftFilterShifts () { this.setShiftFiltersSelected(); },
    shiftFilterProviderOwners () { this.setShiftFiltersSelected(); },
    shiftFilterFacilityOwners () { this.setShiftFiltersSelected(); },
    shiftFilterLogistics () { this.setShiftFiltersSelected(); }
  },
  computed: {
    shiftActionsWarning: function () {
      return this.selectedShifts.some( (item: any) => item.invoiceCount );
    },
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    },
    isFacilityUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT);
    },
    isProviderExists (): boolean {
      return this.selectedShifts.some(shift => shift.providerId);
    }
  },
  methods: {
    setShiftFiltersSelected() {
      this.shiftFiltersSelected = this.sumFilters();
    },
    sumFilters() : number {
      return this.shiftFilterFacilities.length
        + this.shiftFilterSpecialties.length
        + this.shiftFilterProviders.length
        + this.shiftFilterStates.length
        + this.shiftFilterShifts.length
        + this.shiftFilterProviderOwners.length
        + this.shiftFilterFacilityOwners.length
        + this.shiftFilterLogistics.length
    },
    onCalendarBodyScroll () {
      if (this.scrollEventTimeout) {
        clearTimeout(this.scrollEventTimeout);
      }
      let self = this as any;
      this.scrollEventTimeout = setTimeout(function () {
        // Set dropshadow on activated sticky header
        if (self.$refs.weeks && self.$refs.weeks.length && self.calendarBodyElement) {
          let scrollTop = self.calendarBodyElement.scrollTop + self.calendarBodyElement.offsetTop + 3;
          for (let i = 0, leni = self.$refs.weeks.length; i < leni; i++) {
            if ( scrollTop > self.$refs.weeks[i].offsetTop ) {
              self.$refs.weeks[i].className = self.$refs.weeks[i].className.replace(" shadow","");
              self.$refs.weeks[i].className = self.$refs.weeks[i].className + " shadow";
            } else {
              self.$refs.weeks[i].className = self.$refs.weeks[i].className.replace(" shadow","");
            }
          }
        }

      }, 50);
    },
    newShift () {
      this.$router.push({name: 'NewShift'});
    },
    async addWeekShiftToWeeks(weekStartDate: any, clearWeeks: boolean = false) {
      this.clearAssignedUnassignedHoursReport();
      this.loadingData = true;
      try {
        const response = await HTTP.get('/api/calendar-shifts/week/' + weekStartDate + '?includeOpen=' + this.includeOpen + '&isHiatus=' + this.isHiatus);
        this.loadingData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving shifts.");
        }
        let freshWeek = response.data.data;
        this.checkCurrentDay(freshWeek, 'weekDays');
        this.prepareAndSortData(freshWeek);
        if (clearWeeks) {
          let tempWeeks = [];
          tempWeeks.push(freshWeek);
          this.allWeeks = tempWeeks;
        } else {
          this.allWeeks.push(freshWeek);
        }

        // Retrieve the remaining weeks in the month
        let nextWeekDate = new Date(weekStartDate);
        nextWeekDate.setUTCDate(nextWeekDate.getUTCDate() + 7);
        let nextWeekDay = nextWeekDate.getUTCDay() > 0 ? nextWeekDate.getUTCDay() : 7;
        const nextWeekMonth = this.startingDate.getUTCMonth() < 11 ? this.startingDate.getUTCMonth() + 1 : 0;
        if (
          (nextWeekDate.getUTCMonth() === this.startingDate.getUTCMonth()) ||
          (nextWeekDate.getUTCMonth() === nextWeekMonth && ((nextWeekDate.getUTCDate() - nextWeekDay) < 0))
        ) {
          await this.updateFilters(false);
          await this.addWeekShiftToWeeks(nextWeekDate.toISOString().slice(0, 10), false);
        } else {
          await this.updateFilters(true);
        }

        // Remove any mouse hover divs that may be displaying from the previous UI.
        this.shiftMouseLeave();
        this.facilitySpecialtyMouseLeave();

      } catch (err) {
        console.log('response Error!');
        console.log(err);
        this.loadingData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving shifts for the week of ' + weekStartDate
        });
      }
    },
    checkCurrentDay(freshData: any, field: string) {
      let currentDay = new Date();
      const today = new Date(Date.UTC(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate())).toISOString().slice(0,10);
      freshData[field].forEach(function (weekDay: any) {
        if (weekDay.date.slice(0,10) === today) {
          weekDay.isCurrentDay = true;
        }
      });
    },
    prepareAndSortData(data: { facilitySpecialties: any[] }) {
      for (const facSpec of data.facilitySpecialties) {
        facSpec.facilityDisplayName = this.getFacilityDisplayName(facSpec);
      }
      data.facilitySpecialties.sort((a: any, b: any) => {
        const value = a.facilityDisplayName.localeCompare(b.facilityDisplayName, undefined, { sensitivity: 'base' });
        if (value === 0) {
          return a.specialtyShortName.localeCompare(b.specialtyShortName, undefined, { sensitivity: 'base' });
        }
        return value;
      });
    },
    getFacilityDisplayName(facilitySpecialty: any) {
      if (!facilitySpecialty.facilityShortName && facilitySpecialty.facilityName) {
        let facilityNameSegmented = facilitySpecialty.facilityName.split(' ');
        facilityNameSegmented = facilityNameSegmented.map(function (word: string) { return word.trim().slice(0,1); });
        return facilityNameSegmented.join("");
      } else {
        return facilitySpecialty.facilityShortName;
      }
    },
    async getMonthShifts(dateInMonth: any) {
      this.loadingMonthData = true;
      this.clearAssignedUnassignedHoursReport();
      try {

        const response = await HTTP.get('/api/calendar-shifts/month/' + dateInMonth + "?isHiatus=" + this.isHiatus);
        this.loadingMonthData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving shifts.");
        }
        let freshMonth = response.data.data;
        this.checkCurrentDay(freshMonth, 'monthDays');
        this.prepareAndSortData(freshMonth);
        this.monthWeekGridRowStyle = {gridTemplateColumns: "120px repeat(" + freshMonth.monthDays.length * 2 + ", 1fr)"};
        this.wholeMonth = [freshMonth];
        await this.updateFilters();

        // Remove any mouse hover divs that may be displaying from the previous UI.
        this.shiftMouseLeave();
        this.facilitySpecialtyMouseLeave();
      } catch (err) {
        console.log('response Error!');
        console.log(err);
        this.loadingMonthData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving shifts'
        });
      }
    },
    clearAssignedUnassignedHoursReport (showLoadingSpinner: boolean = true) {
      this.assignedHours = "0";
      this.unassignedHours = "0";
      this.totalMonthHours = "0";
      this.assignedPercentage = "0";
      this.unassignedPercentage = "0";
      if (showLoadingSpinner) { this.loadingAssignedUnassignedHoursReport = true; }
    },
    getAssignedUnassignedHoursReport (dateInMonth: any, filteredShiftIds: number [] = []) {
      if (this.isProviderUser || this.isFacilityUser) { return; }
      this.loadingAssignedUnassignedHoursReport = true;
      this.clearAssignedUnassignedHoursReport();
      let self = this
      HTTP.post('/api/calendar-shifts/month/assigned-unassigned-hours-report/' + dateInMonth.toISOString(), {listOfShiftIds: filteredShiftIds, isHiatus: this.isHiatus})
      .then(function (response: any) {
        self.loadingAssignedUnassignedHoursReport = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving report.");
        }
        self.assignedHours = response.data.data.assignedHours.toFixed(2);
        self.unassignedHours = response.data.data.unassignedHours.toFixed(2);
        self.totalMonthHours = (Number(self.assignedHours) + Number(self.unassignedHours)).toFixed(2);
        self.assignedPercentage = ((Number(self.assignedHours)/Number(self.totalMonthHours)) * 100).toFixed(1);
        self.unassignedPercentage = ((Number(self.unassignedHours)/Number(self.totalMonthHours)) * 100).toFixed(1);
      })
      .catch(function (err: any) {
        console.log('response Error!');
        console.log(err);
        self.loadingAssignedUnassignedHoursReport = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving shift hours report.'
        });
      })
    },
    shiftClick (shift: any) {
      let currentTime = new Date().getTime();
      let timeBetweenLastClick = currentTime - this.clickStartTime;
      if (this.isProviderUser || this.isFacilityUser || (this.clickedShiftId === shift.shiftId && timeBetweenLastClick < 500)) {
        // double click or when inside Provider & Facility Portals
        this.$router.push({name: 'Shift', params: {shiftId: shift.shiftId}});
      } else {
        shift.isSelected = !shift.isSelected;
        if (shift.isSelected) {
          this.selectedShifts.push(shift);
        } else {
          this.selectedShifts = this.selectedShifts.filter((obj: any) => { return obj.shiftId !== shift.shiftId });
        }
        for(let i1=0, leni1=this.weeks.length; i1<leni1; i1++) {
          for(let i2=0, leni2=this.weeks[i1].facilitySpecialties.length; i2<leni2; i2++) {
            for(let i3=0, leni3=this.weeks[i1].facilitySpecialties[i2].shifts.length; i3<leni3; i3++) {
              if(this.weeks[i1].facilitySpecialties[i2].shifts[i3].shiftId === shift.shiftId) {
                this.weeks[i1].facilitySpecialties[i2].shifts[i3].isSelected = shift.isSelected;
              }
            }
          }
        }
      }
      this.clickStartTime = currentTime;
      this.clickedShiftId = shift.shiftId;
    },
    shiftMouseOver (shift: any, facility: any, event: any) {
      this.hoveredTasks = ['no-task', 'no-task', 'no-task', 'no-task', 'no-task']
      shift.openTaskTypes.forEach((openTask: any) => {
        if (openTask.isComplete) {
          this.hoveredTasks[openTask.taskType - 2] = 'complete-task'
        } else this.hoveredTasks[openTask.taskType - 2] = 'open-task'
      })

      this.hoveredFacilityName = facility.facilityName;
      this.hoveredSpecialtyName = facility.specialtyName;
      if (shift.providerId) {
        this.hoveredProvider = shift.providerFirstName + ' ' + shift.providerLastName + ' | ' + shift.providerTypeName;
      }
      this.hoveredShiftHours = `${shift.shiftHours} Hrs`;

      this.hoveredStartDatetime = format(convertDateStringToUTCDate(shift.shiftStartDatetime) as any, 'MMM DD, YYYY - hh:mm a');
      this.hoveredEndDatetime = format(convertDateStringToUTCDate(shift.shiftEndDatetime) as any, 'MMM DD, YYYY - hh:mm a');

      if (event.target.className.indexOf('shift') !== -1) {
        const shiftElementX = event.currentTarget.getBoundingClientRect().x || event.currentTarget.getBoundingClientRect().left;
        const parentOffsetLeft = event.currentTarget.offsetParent.offsetLeft;

        setTimeout(() => {
          const shiftInformationElement = this.$refs.shiftInfoBox;
          if (!shiftInformationElement) { return; }
          const shiftInformationElementHeight = (shiftInformationElement as any).clientHeight + 10;
          const shiftInformationElementWidth = (shiftInformationElement as any).clientWidth;

          const shiftElementHeight = event.srcElement.clientHeight;
          const shiftOffsetTopFromParent = event.srcElement.offsetTop;
          const parentOffsetTopFromPage = Math.round(event.srcElement.parentElement.getBoundingClientRect().top);
          const shiftOffsetTopFromPage = shiftOffsetTopFromParent + parentOffsetTopFromPage;

          // Calculate if the shift information hover appears above or below the shift.
          const shiftInformationAmmountToOffsetTop = shiftOffsetTopFromPage < shiftInformationElementHeight ? (shiftOffsetTopFromPage + shiftElementHeight + 3) : shiftOffsetTopFromPage - shiftInformationElementHeight;

          // need to ensure that the hover does not scroll off of the side of the screen.  The offset takes in absolute coordinates
          // to determine if it would scroll off the page and adjusts the offset accordingly
          const shiftInformationHoverOffsetHorizontal = ((window.innerWidth - (shiftElementX + 15) < (shiftInformationElementWidth)))
            ? (shiftInformationElementWidth - (window.innerWidth - (shiftElementX + 15)))
            : 0;
          // the translate requires a relative offset of the calendar to translate "absolute" position(confusing I know) This relative position
          // is required due to the left nav's 75 pixels that are required on semi-collapse state(when the screen is wide enough to support semi collapse)
          this.shiftInformationStyles = {
            transition: 'none',
            transform: 'translate(' + ((shiftElementX - parentOffsetLeft) - shiftInformationHoverOffsetHorizontal) + 'px,' + shiftInformationAmmountToOffsetTop + 'px)'
          } as any ;
        },0);
      }
      this.showShiftInformation = true;
    },
    shiftMouseLeave () {
      this.showShiftInformation = false;
      this.hoveredProvider = '-';
    },
    facilitySpecialtyMouseOver (facility: any, event: any) {
      let self = this;
      self.facilitySpecialtyInformationStyles = {
        transition: 'none',
        transform: 'translate(80px,' + (event.pageY - 120) + 'px)'
      } as any;

      setTimeout(function () {
        self.onHoveredFacilityName = facility.facilityName;
        self.onHoveredSpecialtyName = facility.specialtyName;
        self.showFacilitySpecialtyInformation = true;
      },0);
    },
    facilitySpecialtyMouseLeave () {
      this.showFacilitySpecialtyInformation = false;
    },
    facilitySpecialtyMouseMove (event: any) {
      let self = this;
      self.facilitySpecialtyInformationStyles = {
        transform: 'translate(80px,' + (event.clientY -100) + 'px' + ')'
      } ;
    },
    toggleShiftActionDropdown (shiftActionsWarning: boolean) {
      if (!shiftActionsWarning) {
        this.showShiftActionsDropdown = !this.showShiftActionsDropdown;
      } else {
        // display warning modal
        this.showShiftActionsWarningModal = !this.showShiftActionsWarningModal;
      }
    },
    confirmationModalConfigurationAndShow (confirmationModalVerbiage: string, confirmationModalAction: () => void ) {
      this.confirmationModalVerbiage = confirmationModalVerbiage;
      this.confirmationModalAction = confirmationModalAction;
      this.showShiftActionsDropdown = false;
      this.showConfirmationModal = true;
    },
    shiftActionDeselectShifts () {
      this.showShiftActionsDropdown = false;
      for (let i1=0, leni1=this.weeks.length; i1<leni1; i1++) {
        for (let i2=0, leni2=this.weeks[i1].facilitySpecialties.length; i2<leni2; i2++) {
          for (let i3=0, leni3=this.weeks[i1].facilitySpecialties[i2].shifts.length; i3<leni3; i3++) {
            this.weeks[i1].facilitySpecialties[i2].shifts[i3].isSelected = false;
          }
        }
      }
      for (let mi1=0, lenmi1=this.months.length; mi1<lenmi1; mi1++) {
        for (let mi2=0, lenmi2=this.months[mi1].facilitySpecialties.length; mi2<lenmi2; mi2++) {
          for (let mi3=0, lenmi3=this.months[mi1].facilitySpecialties[mi2].shifts.length; mi3<lenmi3; mi3++) {
            this.months[mi1].facilitySpecialties[mi2].shifts[mi3].isSelected = false;
          }
        }
      }
      this.selectedShifts = [];
    },
    async reloadCalendarToDate (date: Date) {
      this.startingDate = date;
      await this.reloadCalendar();
    },
    async reloadCalendar () {
      this.selectedShifts = [];
      this.showShiftActionsDropdown = false;
      this.reloadingData = false;
      if (this.isWeekView) {
        await this.addWeekShiftToWeeks(this.startingDate.toISOString().slice(0,10), true);
      } else {
        await this.getMonthShifts(this.startingDate.toISOString().slice(0,10));
      }
    },
    shiftActionsDeleteShifts () {
      this.showConfirmationModal = false;
      let arrayOfPromises: any[] = [];
      let successfulEvents = 0;
      let unsuccessfulEventsList: any[] = [];
      let self = this;

      self.reloadingData = true;
      this.selectedShifts.forEach( function (shift: any) {
        arrayOfPromises.push(
          HTTP.delete('/api/shifts/' + shift.shiftId + '/archive-shift/')
          .then(function (response: any) {
            if (!response.data || !response.data.success) { throw new Error("Error deleting shift."); }
            successfulEvents++;
          })
          .catch(function (err: any) {
            console.log('response Error!!');
            console.log(err);
            unsuccessfulEventsList.push({
              shift: shift,
              error: err
            });
          })
        );
      });

      // A way to respond after all of the shift creation promises have returned.
      Promise.all(arrayOfPromises)
      .then(function (values) {
        if (successfulEvents > 0) {
          let wordShift = (successfulEvents && successfulEvents > 1) ? ' shifts!' : ' shift!';
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success!',
            text: 'You successfully deleted ' + successfulEvents + wordShift
          });
        }
        if (unsuccessfulEventsList.length) { throw new Error("Error deleting shifts."); }
        self.reloadCalendar().catch(() => {});
      })
      .catch(function (err) {
        console.log('error value');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Failed to delete ' + unsuccessfulEventsList.length + ' of the ' + arrayOfPromises.length + ' shifts.'
        });
        console.log('Unsuccessful shift deletions:');
        console.log(unsuccessfulEventsList);
        self.reloadCalendar().catch(() => {});
      })
    },
    shiftActionsHiatusShifts () {
      this.showConfirmationModal = false;
      let arrayOfPromises: any[] = [];
      let successfulEvents = 0;
      let unsuccessfulEventsList: any[] = [];
      let self = this;

      self.reloadingData = true;
      this.selectedShifts.forEach( function (shift: any) {
        arrayOfPromises.push(
          HTTP.put('/api/shifts/' + shift.shiftId + '/hiatus/')
          .then(function (response: any) {
            if (!response.data || !response.data.success) { throw new Error("Error updating shift."); }
            successfulEvents++;
          })
          .catch(function (err: any) {
            console.log('response Error!!');
            console.log(err);
            unsuccessfulEventsList.push({
              shift: shift,
              error: err
            });
          })
        );
      });

      // A way to respond after all of the shift creation promises have returned.
      Promise.all(arrayOfPromises)
      .then(function (values) {
        if (successfulEvents > 0) {
          let wordShift = (successfulEvents && successfulEvents > 1) ? ' shifts!' : ' shift!';
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success!',
            text: 'You successfully updated ' + successfulEvents + wordShift + ' to Hiatus.'
          });
        }
        if (unsuccessfulEventsList.length) { throw new Error("Error updating shift."); }
        self.reloadCalendar().catch(() => {});
      })
      .catch(function (err) {
        console.log('error value');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Failed to update ' + unsuccessfulEventsList.length + ' of the ' + arrayOfPromises.length + ' shifts.'
        });
        console.log('Unsuccessful hiatus shift updates:');
        console.log(unsuccessfulEventsList);
        self.reloadCalendar().catch(() => {});
      })
    },
    shiftActionsRemoveProvider () {
      this.showConfirmationModal = false;
      let arrayOfPromises: any[] = [];
      let successfulEvents = 0;
      let unsuccessfulEventsList: any[] = [];
      let self = this;

      self.reloadingData = true;
      this.selectedShifts.forEach( function (shift: any) {
        arrayOfPromises.push(
          HTTP.delete('/api/shifts/' + shift.shiftId + '/providers/0')
          .then(function (response: any) {
            if (!response.data || !response.data.success) { throw new Error("Error removing provider from shift."); }
            successfulEvents++;
          })
          .catch(function (err: any) {
            console.log('response Error!!');
            console.log(err);
            unsuccessfulEventsList.push({
              shift: shift,
              error: err
            });
          })
        );
      });

      // A way to respond after all of the shift creation promises have returned.
      Promise.all(arrayOfPromises)
      .then(function (values) {
        if (successfulEvents > 0) {
          let wordShift = (successfulEvents && successfulEvents > 1) ? ' shifts!' : ' shift!';
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success!',
            text: 'You successfully removing provider from ' + successfulEvents + wordShift
          });
        }
        if (unsuccessfulEventsList.length) { throw new Error("Error removing provider from shift."); }
        self.reloadCalendar().catch(() => {});
      })
      .catch(function (err) {
        console.log('error value');
        console.log(err);
        // anErrorOccured = true;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Failed to removing provider from ' + unsuccessfulEventsList.length + ' of the ' + arrayOfPromises.length + ' shifts.'
        });
        console.log('Unsuccessful removing provider from shift updates:');
        console.log(unsuccessfulEventsList);
        self.reloadCalendar().catch(() => {});
      })
    },
    showProviderModal () {
      this.showShiftActionsDropdown = false;
      this.showProviderSelectionModal = true;
    },
    confirmProvider (provider: any) {
      this.showProviderSelectionModal = false;
      this.providerToAssign = provider;
      this.confirmationModalConfigurationAndShow(
        'These shifts will be assigned to:<div style="margin-top:7px;">' + provider.name + '</div>',
        () => {
          this.shiftActionsAssignProvider(provider, true)
            .catch(() => {})
            .then(() => {
              this.providerToAssign = null;
              return this.reloadCalendar().catch(() => {});
            }).catch(() => {});
        })
    },
    async confirmProviderWithLogistics () {
      await this.shiftActionsAssignProvider(this.providerToAssign, false);
      this.showLogisticsModal = true;
    },
    cancelProviderModal () {
      this.providerToAssign = null;
      this.showConfirmationModal = false;
    },
    async closeLogisticsConfirmationModal(shiftCount?: number) {
      if (shiftCount) {
        // show success message ONLY if 'No Logistics Needed' was clicked
        let wordShift = (shiftCount && shiftCount > 1) ? ' shifts!' : ' shift!';
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success!',
          text: 'You successfully assigned ' + (this.providerToAssign as any).name + ' to ' + shiftCount + wordShift
        });
      }
      this.showLogisticsModal = false;
      this.providerToAssign = null;
      await this.reloadCalendar();
    },
    async shiftActionsAssignProvider (provider: any, showSuccessMessage: boolean) {
      this.showConfirmationModal = false;
      let arrayOfPromises: any[] = [];
      let successfulEvents = 0;
      let unsuccessfulEventsList: any[] = [];
      let self = this;

      self.reloadingData = true;
      this.selectedShifts.forEach( function (shift: any) {
        arrayOfPromises.push(
          HTTP.put('/api/shifts/' + shift.shiftId + '/providers/' + provider.id)
          .then(function (response: any) {
            if (!response.data || !response.data.success) { throw new Error("Error removing provider from shift."); }
            successfulEvents++;
          })
          .catch(function (err: any) {
            console.log('response Error!!');
            console.log(err);
            unsuccessfulEventsList.push({
              shift: shift,
              error: err
            });
          })
        );
      });

      // A way to respond after all of the shift creation promises have returned.
      return Promise.all(arrayOfPromises)
      .then( (values) => {
        if (successfulEvents > 0 && showSuccessMessage) {
          let wordShift = (successfulEvents && successfulEvents > 1) ? ' shifts!' : ' shift!';
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success!',
            text: 'You successfully assigned ' + provider.name + ' to ' + successfulEvents + wordShift
          });
        }
        if (unsuccessfulEventsList.length) { throw new Error("Error assigning provider to shift."); }
      })
      .catch(function (err) {
        console.log('error value');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Failed to assign provider to ' + unsuccessfulEventsList.length + ' of the ' + arrayOfPromises.length + ' shifts.'
        });
        console.log('Unsuccessful assigning provider to shift:');
        console.log(unsuccessfulEventsList);
      })
    },

    async monthChanged (newDate: any) {
      await this.$store.dispatch('viewState/updateViewState', {name: ViewStateType.CALENDAR_STARTING_DATE, value: newDate});
      await this.reloadCalendarToDate(newDate);
    },

    showShiftFilters () {
      this.showShiftFiltersDropdown = !this.showShiftFiltersDropdown;
      setTimeout( () => {
        (this.$refs.searchFilterInput as any).focus();
        (this.$refs.searchFilterInput as any).select();
      }, 100);
    },
    async selectFilter (shiftFilter: Filter) {
      let existingFilters = [];
      function findDuplicateFilters (filterArray: any) {
        existingFilters = filterArray.filter((item: any) => item.id === shiftFilter.id);
      }
      switch (shiftFilter.shiftFilterTypeId) {
        // Facility
        case 1:
          findDuplicateFilters(this.shiftFilterFacilities);
          if (!existingFilters.length) { this.shiftFilterFacilities.push(shiftFilter); }
          break;
        // Specialty
        case 2:
          findDuplicateFilters(this.shiftFilterSpecialties);
          if (!existingFilters.length) { this.shiftFilterSpecialties.push(shiftFilter); }
          break;
        // Provider
        case 3:
          findDuplicateFilters(this.shiftFilterProviders);
          if (!existingFilters.length) { this.shiftFilterProviders.push(shiftFilter); }
          break;
        // State
        case 4:
          findDuplicateFilters(this.shiftFilterStates);
          if (!existingFilters.length) { this.shiftFilterStates.push(shiftFilter); }
          break;
        // Shifts
        case 5:
          findDuplicateFilters(this.shiftFilterShifts);
          if (!existingFilters.length) {
            if (!this.isHiatus && shiftFilter.id === HAITUS_ID) {
              this.isHiatus = true;
              await this.reloadCalendar();
            }
            this.shiftFilterShifts.push(shiftFilter);
          }
          break;
        // Provider Owners
        case 6:
          findDuplicateFilters(this.shiftFilterProviderOwners);
          if (!existingFilters.length) { this.shiftFilterProviderOwners.push(shiftFilter); }
          break;
        // Facility Owners
        case 7:
          findDuplicateFilters(this.shiftFilterFacilityOwners);
          if (!existingFilters.length) { this.shiftFilterFacilityOwners.push(shiftFilter); }
          break;
        // Logistics
        case 8:
          findDuplicateFilters(this.shiftFilterLogistics);
          if (!existingFilters.length) { this.shiftFilterLogistics.push(shiftFilter); }
          break;
        default:
          break;
      }
      await this.updateFilters();
    },
    async unselectFilter (shiftFilter: any) {
      switch (shiftFilter.shiftFilterTypeId) {
        // Facility
        case 1:
          this.shiftFilterFacilities = this.shiftFilterFacilities.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Specialty
        case 2:
          this.shiftFilterSpecialties = this.shiftFilterSpecialties.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Provider
        case 3:
          this.shiftFilterProviders = this.shiftFilterProviders.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // State
        case 4:
          this.shiftFilterStates = this.shiftFilterStates.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Shifts
        case 5:
          if (this.isHiatus && shiftFilter.id === HAITUS_ID) {
            this.isHiatus = false;
            await this.reloadCalendar();
          }
          this.shiftFilterShifts = this.shiftFilterShifts.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Provider Owners
        case 6:
          this.shiftFilterProviderOwners = this.shiftFilterProviderOwners.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Facility Owners
        case 7:
          this.shiftFilterFacilityOwners = this.shiftFilterFacilityOwners.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        // Logistics
        case 8:
          this.shiftFilterLogistics = this.shiftFilterLogistics.filter( (item:any) => shiftFilter.name !== item.name );
          break;
        default:
          break;
      }
      await this.updateFilters();
    },
    async clearAllFilters () {
      this.shiftFilterFacilities = [];
      this.shiftFilterSpecialties = [];
      this.shiftFilterProviders = [];
      this.shiftFilterStates = [];
      this.shiftFilterShifts = [];
      this.shiftFilterProviderOwners = [];
      this.shiftFilterFacilityOwners = [];
      this.shiftFilterFilled = [];
      this.shiftFilterLogistics = [];
      if (this.isHiatus) {
        this.isHiatus = false;
        await this.reloadCalendar();
      }
      await this.updateFilters();
    },
    updateSelectedFilter (shiftFilterTypes: any, shiftFilterType: any) {
      shiftFilterTypes.forEach( (shiftFilterInstance: any) => {
        shiftFilterInstance.isSelected = shiftFilterInstance.id === shiftFilterType.id;
        if(shiftFilterType.id === 5){
          this.shiftSearchResults = [
            {"id": FILLED_ID, "name":"Display Filled Shifts", "shiftFilterTypeId": shiftFilterType.id},
            {"id": UNFILLED_ID, "name":"Display Unfilled Shifts", "shiftFilterTypeId": shiftFilterType.id},
            {"id": HAITUS_ID, "name":"Display Hiatus Shifts", "shiftFilterTypeId": shiftFilterType.id}
          ];
          this.shiftFilterSearchInput = '';
          this.searchCountResults = this.shiftSearchResults.length;
          (this.$refs.searchFilterInput as any).setAttribute('disabled','');
          // (this.$refs.searchFilterInput as any).disabled();
          // (this.$refs.searchFilterInput as any).select()
        } else if(shiftFilterType.id === 8){
          this.shiftSearchResults = [
            {"id": ALL_OPEN_ID, "name":"Display All Open Logistics", "shiftFilterTypeId": shiftFilterType.id},
            {"id": OPEN_TRAVEL_ID, "name":"Display Open Travel Logistics", "shiftFilterTypeId": shiftFilterType.id},
            {"id": OPEN_LICENSING_ID, "name":"Display Open Licensing Logistics", "shiftFilterTypeId": shiftFilterType.id},
            {"id": OPEN_CREDENTIALING_ID, "name":"Display Open Credentialing Logistics", "shiftFilterTypeId": shiftFilterType.id},
            {"id": ALL_LOGISTICS_ID, "name":"Display All Logistics", "shiftFilterTypeId": shiftFilterType.id}
          ];
          this.shiftFilterSearchInput = '';
          this.searchCountResults = this.shiftSearchResults.length;
          (this.$refs.searchFilterInput as any).setAttribute('disabled','');
        } else {
          this.shiftFilterSearchInput = '';
          this.shiftSearchResults = [];
          this.searchCountResults = 0;
          (this.$refs.searchFilterInput as any).removeAttribute('disabled');
          (this.$refs.searchFilterInput as any).focus();
          (this.$refs.searchFilterInput as any).select();
        }
      });
    },
    async updateFilters (updateHoursReport: boolean = true) {
      this.weeks = this.shiftsFilterChange(this.allWeeks);
      this.months = this.shiftsFilterChange(this.wholeMonth);

      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_FACILITIES, value: this.shiftFilterFacilities.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_PROVIDERS, value: this.shiftFilterProviders.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_SPECIALTIES, value: this.shiftFilterSpecialties.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_STATES, value: this.shiftFilterStates.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_SHIFTS, value: this.shiftFilterShifts.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_PROVIDER_OWNERS, value: this.shiftFilterProviderOwners.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_FACILITY_OWNERS, value: this.shiftFilterFacilityOwners.slice()} ).catch(() => {});
      this.$store.dispatch('viewState/updateViewState', { name: ViewStateType.CALENDAR_SHIFT_FILTER_LOGISTICS, value: this.shiftFilterLogistics.slice()} ).catch(() => {});

      if(updateHoursReport) {
        let filteredShiftIds: number [] = [];
        if(this.calendarHasShiftFilters()){
          filteredShiftIds =
            this.isWeekView ?
            this.getShiftIds(this.weeks) :
            this.getShiftIds(this.months) ;
        }
        this.getAssignedUnassignedHoursReport(this.startingDate, filteredShiftIds);
      }
    },
    getShiftIds(weeksOrMonths: any []) {
      let filteredShiftIds: number [] = [];
      for (let mi1=0, lenmi1=weeksOrMonths.length; mi1<lenmi1; mi1++) {
        for (let mi2=0, lenmi2=weeksOrMonths[mi1].facilitySpecialties.length; mi2<lenmi2; mi2++) {
          for (let mi3=0, lenmi3=weeksOrMonths[mi1].facilitySpecialties[mi2].shifts.length; mi3<lenmi3; mi3++) {
            filteredShiftIds.push(weeksOrMonths[mi1].facilitySpecialties[mi2].shifts[mi3].shiftId);
          }
        }
      }
      return filteredShiftIds;
    },
    shiftsFilterChange (allWeeks: any []) {
      const tempAllWeeks = JSON.parse(JSON.stringify( allWeeks ));
      let tempWeeks = [] as any [];
      for (const week of tempAllWeeks) {
        const tempFacilitySpecialties = [];
        for (const facSpec of week.facilitySpecialties) {
          if (!this.passesFilter(this.shiftFilterFacilities, facSpec, 'facilityId')) {
            continue;
          } else if (!this.passesFilter(this.shiftFilterSpecialties, facSpec, 'specialtyId')) {
            continue;
          } else if (!this.passesFilter(this.shiftFilterStates, facSpec, 'facilityStateId')) {
            continue;
          } else if (!this.passesFilter(this.shiftFilterFacilityOwners, facSpec, 'facilityNmrEmployeeOwnerId')) {
            continue;
          }

          const tempFacilitySpecialtiesShifts = [];
          for (const shift of facSpec.shifts) {
            if (!this.passesFilter(this.shiftFilterProviders, shift, 'providerId')) {
              continue;
            } else if (!this.passesFilledFilter(this.shiftFilterFilled, shift.providerId)) {
              continue;
            } else if (!this.passesFilledFilter(this.shiftFilterShifts, shift.providerId)) {
              continue;
            } else if (!this.passesFilter(this.shiftFilterProviderOwners, shift, 'providerNmrEmployeeOwnerId')
                          && !this.passesFilter(this.shiftFilterProviderOwners, shift, 'providerNmrEmployeeCoOwnerId')) {
              continue;
            } else if (!this.passesLogisticsFilter(this.shiftFilterLogistics, shift)) {
              continue;
            }
            tempFacilitySpecialtiesShifts.push(shift);
          }
          if (tempFacilitySpecialtiesShifts.length === 0) {
            continue;
          }
          facSpec.shifts = tempFacilitySpecialtiesShifts;
          tempFacilitySpecialties.push(facSpec);
        }

        const tempWeek = week;
        tempWeek.facilitySpecialties = tempFacilitySpecialties;
        tempWeeks.push(tempWeek);
      }

      return this.calendarHasShiftFilters() ? tempWeeks : allWeeks;
    },
    calendarHasShiftFilters () {
      return (this.sumFilters() > 0);
    },
    passesFilter(filters: any[], toCheck: any, idField: string): boolean {
      if (filters.length === 0) {
        return true;
      }
      for (const filter of filters) {
        if (filter.id === toCheck[idField]) {
          return true;
        }
      }
      return false;
    },
    passesFilledFilter(shiftFilledFilters: any[], providerId: number): boolean {
      const filtersToEvaluate = shiftFilledFilters.filter((shiftFilter) => shiftFilter.id !== HAITUS_ID);
      if (filtersToEvaluate.length === 0) {
        return true;
      }
      for (const filter of filtersToEvaluate) {
        if ((filter.id === UNFILLED_ID && !providerId) || (filter.id === FILLED_ID && Number(providerId) > 0)) {
          return true;
        }
      }
      return false;
    },
    passesLogisticsFilter(shiftFilterLogistics: any[], shift: any){
      if (shiftFilterLogistics.length === 0) {
        return true;
      }
      const includesTravel = shift.openTaskTypes.find((task: any) => ((task.taskType === TaskTypeForCalendarShiftHoverEnum.FLIGHT && !task.isComplete) || (task.taskType === TaskTypeForCalendarShiftHoverEnum.HOTEL && !task.isComplete) || (task.taskType === TaskTypeForCalendarShiftHoverEnum.CAR && !task.isComplete)));
      const includesLicensing = shift.openTaskTypes.find((task: any) => (task.taskType === TaskTypeForCalendarShiftHoverEnum.LICENSING && !task.isComplete));
      const includesCredentials = shift.openTaskTypes.find((task: any) => (task.taskType === TaskTypeForCalendarShiftHoverEnum.CREDENTIALS && !task.isComplete));
      const allOpen = shift.openTaskTypes.some((task: any) => !task.isComplete);
      const allLogistics = Boolean(shift.openTaskTypes.length);
      for (const filter of shiftFilterLogistics) {
        if ((filter.id === ALL_OPEN_ID && allOpen) ||
            (filter.id === OPEN_TRAVEL_ID && includesTravel) ||
            (filter.id === OPEN_LICENSING_ID && includesLicensing) ||
            (filter.id === OPEN_CREDENTIALING_ID && includesCredentials) ||
            (filter.id === ALL_LOGISTICS_ID && allLogistics)) {
          return true;
        }
      }
      return false;
    },
    shiftFilterSearch (shiftFilterTypes: any[]) {
      let self = this;
      if (this.processingShiftFilterSearch) { return; }
      this.processingShiftFilterSearch = true;
      (this as any).performSearchTimeout = setTimeout(function () {
        let showLoadingSpinnerTimeout = setTimeout(function () {
          self.loadingShiftFilterSearchResults = true;
        }, 0);
        let currentSearchInput = self.shiftFilterSearchInput;
        let currentlySelectedShiftFilter = shiftFilterTypes.filter((shiftFilterType: any) => { return shiftFilterType.isSelected; } );
        if (!currentlySelectedShiftFilter[0]) { throw new Error("Error searching filter types."); }
        HTTP.get(currentlySelectedShiftFilter[0].searchAPI + self.shiftFilterSearchInput + '&forceResults=false&excludeInactive=true')
        .then(function (response) {
          self.processingShiftFilterSearch = false;
          // If the response is a count, display the count message
          // If the response is a list, display the list
          // If the search results results are empty, display the count
          // If the count is greater than 0 display the count at the option to force retrieving the results
          //  as long as the results are less than 150

          self.searchCountResults = response.data.data.count;
          self.shiftSearchResults = currentlySelectedShiftFilter[0].conditionResponseData(response.data.data.results);

          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingShiftFilterSearchResults = false;

          if (self.shiftFilterSearchInput !== currentSearchInput) {
            self.shiftFilterSearch(shiftFilterTypes);
          }
        })
        .catch((error) => {
          console.log('error', error);
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingShiftFilterSearchResults = false;

          self.processingShiftFilterSearch = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Getting Results',
            text: 'Searching filters failed.',
          });
        })
      }, 100);
    },
    async showAll() {
      this.includeOpen = true;
      await this.reloadCalendar();
    },
    async showMine() {
      this.includeOpen = false;
      await this.reloadCalendar();
    },
    async facilityUserFilterChanged (filters: any[]) {
      this.shiftFilterFacilities = [];
      this.shiftFilterSpecialties = [];
      this.shiftFilterFilled = [];
      for (const filter of filters) {
        if (filter.filterTypeId === FACILITY_FILTER_TYPE) {
          this.shiftFilterFacilities.push(filter);
        } else if (filter.filterTypeId === SPECIALTY_FILTER_TYPE) {
          this.shiftFilterSpecialties.push(filter);
        } else if (filter.filterTypeId === SHIFT_FILTER_TYPE) {
          this.shiftFilterFilled.push(filter);
        }
      }
      await this.updateFilters();
    },
    print() {
      window.print();
    },

    async toggleWeekMonthView(currentIsWeekView: boolean) {
      this.isWeekView = !currentIsWeekView;
      this.weekMonthViewLabel = this.isWeekView ? "Show Month View" : "Show Week View";
      this.startingDate.setUTCDate(1);
      await this.monthChanged(this.startingDate);
    },

    async facilitySpecialtyLabelClick(facilitySpecialty: any) {
      if(this.isProviderUser || this.isFacilityUser ){ return; }

      let newFacilityFilter = {
        id: facilitySpecialty.facilityId,
        name: facilitySpecialty.facilityName,
        shiftFilterTypeId: FACILITY_FILTER_TYPE
      }
      let newSpecialtyFilter = {
        id: facilitySpecialty.specialtyId,
        name: facilitySpecialty.specialtyName,
        shiftFilterTypeId: SPECIALTY_FILTER_TYPE
      }
      await this.selectFilter(newFacilityFilter);
      await this.selectFilter(newSpecialtyFilter);
      this.facilitySpecialtyMouseLeave();
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/calendarShifts/CalendarShifts.ts